import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

//PROJECT IMPORTS
import ApproveCurrentAcc from "./ApproveCurrentAcc";
import ActivateCurrentAcc from "./ActivateCurrentAcc";
import PostInterestAsOnCurrentAcc from "./PostInterestAsOnCurrentAcc";
import DepositCurrentAcc from "./DepositCurrentAcc";
import WithdrawCurrentAcc from "./WithdrawCurrentAcc";
import AssignStaffCurrentAcc from "./AssignStaffCurrentAcc";
import UndoApprovalCurrentAcc from "./UndoApprovalCurrentAcc";
import TransferFundsCurrentAcc from "./TransferFundsCurrentAcc";
import RejectCurrentAcc from "./RejectCurrentAcc";
import WithdrawnByApplicantCurrentAcc from "./WithdrawnByApplicantCurrentAcc";
import UnassignStaffCurrentAcc from "./UnassignStaffCurrentAcc";
import HoldCurrentAcc from "./HoldCurrentAcc";
import AddChargeCurrentAcc from "./AddChargeCurrentAcc";
import CloseCurrentAcc from "./CloseCurrentAcc";
import ModifyCurrentAcc from "./editCurrentAcc/ModifyCurrentAcc";
import Kyc from "./Kyc";
import ManageAccountAction from "./ManageAccountAction";
import NewStandingInstruction from "./NewStandingInstruction";
import HoldItems from "./HoldItems";
import ManageChequeBookRequest from "./chequeBookRequest/ManageChequeBookRequest";

const CurrentMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  useEffect(() => {}, []);

  const renderActions = () => {
    console.log(state?.actionLabel?.toLowerCase());
    switch (state?.actionLabel?.toLowerCase()) {
      case "modify application":
        return <ModifyCurrentAcc userData={userData} />;
      case "approve":
        return <ApproveCurrentAcc userData={userData} />;
      case "activate":
        return <ActivateCurrentAcc userData={userData} />;
      case "post interest as on":
        return <PostInterestAsOnCurrentAcc userData={userData} />;
      case "deposit":
        return <DepositCurrentAcc userData={userData} />;
      case "withdraw":
        return <WithdrawCurrentAcc userData={userData} />;
      case "assign officer":
      case "change officer":
        return (
          <AssignStaffCurrentAcc
            userData={userData}
            pageTitleParam={state?.actionLabel}
          />
        );
      case "undo approval":
        return <UndoApprovalCurrentAcc userData={userData} />;
      case "transfer funds":
        return <TransferFundsCurrentAcc userData={userData} />;
      case "reject":
        return <RejectCurrentAcc userData={userData} />;
      case "withdrawn by applicant":
        return <WithdrawnByApplicantCurrentAcc userData={userData} />;
      case "unassign officer":
        return <UnassignStaffCurrentAcc userData={userData} />;
      case "hold":
        return <HoldCurrentAcc userData={userData} />;
      case "unhold":
        return <HoldCurrentAcc userData={userData} />;
      case "add charge":
        return <AddChargeCurrentAcc userData={userData} />;
      case "close":
        return <CloseCurrentAcc userData={userData} />;
      case "kyc":
        return <Kyc userData={userData} />;
      case "manage account":
        return <ManageAccountAction userData={userData} />;
      case "cheque book request":
        return <ManageChequeBookRequest userData={userData} />;
      case "new standing instructions":
        return <NewStandingInstruction userData={userData} />;
      case "hold items":
        return <HoldItems userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(CurrentMainActionPage);
